import { useEffect } from 'react'
import i18n from 'i18next'
import moment from 'moment-timezone'
import { ConfigProvider } from 'antd'
import { initReactI18next } from 'react-i18next'

import en_US from 'antd/lib/locale-provider/en_US'

import { useAuth } from './context/auth-context'
import { i18nTranslationsWebEn } from './i18n/i18n-web.en'

import 'moment/locale/be'
import 'moment/locale/de-at'
import 'moment/locale/de'
import 'moment/locale/en-gb'
import 'moment/locale/en-in'
import 'moment/locale/en-nz'
import 'moment/locale/fr-ch'
import 'moment/locale/fr'
import 'moment/locale/hr'
import 'moment/locale/it'
import 'moment/locale/nl-be'
import 'moment/locale/nl'
import 'moment/locale/pl'
import 'moment/locale/pt-br'
import 'moment/locale/ro'
import 'moment/locale/zh-cn'
import 'moment/locale/zh-hk'

export const AntDesignAndMomentLocaleProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { user } = useAuth()

  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: Object.assign({}, i18nTranslationsWebEn),
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

  useEffect(() => {
    if (!!user) {
      moment.locale(user.locale)
    }
  }, [user])

  return <ConfigProvider locale={en_US}>{children}</ConfigProvider>
}
